
interface IActionBarProps {
    children: React.ReactNode;
}

export default function ActionBar(props: IActionBarProps) {
    return <div className="display--flex flex__wrap--wrap margin__top--s justifyContent--space-between">
        <div className="display--flex gap--s">
            {props.children}
        </div>
    </div>
}